<h1 mat-dialog-title [class.mat-dialog-no-bottom-margin]="!showOptions && listeFiltres && optionSelected && (optionSelected.valeur == 1 || optionSelected.valeur == 4)">
    <i class="nio icon-transfere clickable" (click)="onGoBack()" *ngIf="!showOptions && data.liste.extraOptions.options?.length > 1"></i>
    <span>{{ 'admin.frais.prestations.detail.filtres.listeFiltres.addFiltreTitle' | translate }}</span>
    <span [mat-dialog-close]="true"><i class="zmdi zmdi-close"></i></span>
</h1>
<div mat-dialog-content>
    <div class="listview" *ngIf="showOptions && data.liste.extraOptions.options">
        <div class="listview-body">
            <div class="listview-item" *ngFor="let option of data.liste.extraOptions.options">
                <div class="lvi-content">
                    <div class="avatar">{{ option.avatar }}</div>
                    <div class="lvi-body">
                        <div class="title">
                            <a class="label" (click)="selectOption(option)">{{ option.libelle }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <form *ngIf="!showOptions && listeFiltres && optionSelected && (optionSelected.valeur == TypeFiltre.FILTRE_MOT_CLE || optionSelected.valeur == TypeFiltre.FILTRE_ORGANISATION)">
        <fieldset>
            <div class="row">
                <custom-input ngDefaultControl
                              id="isParException"
                              name="isParException"
                              [ngModel]="isParException"
                              [(customModel)]="isParException"
                              lCol="6"
                              rCol="6"
                              customType="checkbox"
                              libelle="admin.frais.prestations.detail.filtres.listeFiltres.parException"
                              postLibelle="admin.frais.prestations.detail.filtres.listeFiltres.parExceptionTooltip">
                </custom-input>
            </div>
        </fieldset>
    </form>
    <list-view *ngIf="!showOptions && listeFiltres" [liste]="listeFiltres"></list-view>
</div>